import React, { FC, useState } from 'react'
import Button from '@material-ui/core/Button'
import Portal from '@material-ui/core/Portal'
import { makeStyles } from '@material-ui/core/styles'
import { stopImpersonate } from '../../helpers'

// Above every MUI dialog (1300) and the header's own menu (1400): an admin
// impersonating a customer sees exactly what the customer sees, and some of
// that cannot be closed (a locked cellular bill, the welcome flow). This is
// the way out that is always there.
export const IMPERSONATION_EXIT_Z_INDEX = 1600

const useStyles = makeStyles({
  exit: {
    position: 'fixed',
    bottom: 16,
    left: 16,
    zIndex: IMPERSONATION_EXIT_Z_INDEX,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)'
  }
})

interface ImpersonationExitProps {
  // The admin behind the session; nothing renders without one.
  adminId?: string | null
}

export const ImpersonationExit: FC<ImpersonationExitProps> = ({ adminId }) => {
  const classes = useStyles()
  const [leaving, setLeaving] = useState(false)
  if (!adminId) return null

  const leave = () => {
    setLeaving(true)
    stopImpersonate().catch(() => setLeaving(false))
  }

  return (
    <Portal>
      <Button
        className={classes.exit}
        color='secondary'
        disabled={leaving}
        onClick={leave}
        size='small'
        variant='contained'
      >
        {leaving ? 'Stopping…' : 'Stop impersonation'}
      </Button>
    </Portal>
  )
}
